import React from 'react'
import { connect } from 'react-redux'
import PasswordRecoveryInitForm from './PasswordRecoveryInitForm'
import PasswordRecoveryCommitForm from './PasswordRecoveryCommitForm'

const mapStateToProps = (state) => ({
  codeSent: state.password_recovery.codeSent
})

@connect(mapStateToProps)
class PasswordRecoveryForm extends React.Component {
  render = () => (
    !this.props.codeSent ? <PasswordRecoveryInitForm/> : <PasswordRecoveryCommitForm/>
  )
}

export default PasswordRecoveryForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/PasswordRecoveryForm/index.js